import type { ZealApiResponse } from "@zeal/common";
import type { CreateWorkLocationRequestBody } from "./CreateWorkLocationRequestBody.jsonschema";
import type { CreateWorkLocationResponseBody } from "./CreateWorkLocationResponseBody.jsonschema";
import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { returnZealApiErrorResponse } from "../../returnZealApiErrorResponse";

const PATH = "workLocations";

type CreateWorkLocationResponse =
  ZealApiResponse<CreateWorkLocationResponseBody>;

export const createWorkLocation =
  (axios: IAxiosInstance) => async (body: CreateWorkLocationRequestBody) => {
    try {
      const response = await axios.noRetry.post<CreateWorkLocationResponse>(
        PATH,
        body
      );
      return response.data;
    } catch (err) {
      return returnZealApiErrorResponse(err);
    }
  };
